import { jsx as _jsx } from "react/jsx-runtime";
import { createCustomBlockSpec } from '../../routines/createCustomBlockSpec.js';
export const Blockquote = createCustomBlockSpec({
    content: 'inline',
    propSchema: {
        text: {
            default: '',
        },
    },
    type: 'blockquote',
}, {
    render: (props) => {
        if (props.readOnly) {
            return (_jsx("blockquote", { style: { whiteSpace: 'pre-line' }, children: _jsx("p", { children: props.content }) }));
        }
        return (_jsx("blockquote", { style: { whiteSpace: 'pre-line' }, children: _jsx("p", { ref: props.contentRef }) }));
    },
    toExternalHTML: ({ contentRef }) => {
        return (_jsx("blockquote", { children: _jsx("p", { ref: contentRef }) }));
    },
});
//# sourceMappingURL=Blockquote.js.map